import { HTMLAttributes, type PropsWithChildren } from 'react';
import { tv } from '../_lib/utils';

const styles = tv({
	slots: {
		base: 'mx-auto [.no-nested-containers_&]:[--container-padding:0]! px-[var(--container-padding)] md:[--container-padding:2.5rem] lg:[--container-padding:4rem]',
	},
	variants: {
		size: {
			default: {
				base: 'max-w-max-default',
			},
			lg: {
				base: 'max-w-max-lg',
			},
			md: {
				base: 'max-w-max-md',
			},
			sm: {
				base: 'max-w-max-sm',
			},
			xs: {
				base: 'max-w-max-xs',
			},
			'2xs': {
				base: 'max-w-max-2xs',
			},
			'editorial-widest': {
				base: 'max-w-max-editorial-widest',
			},
			'editorial-wide': {
				base: 'max-w-max-editorial-wide',
			},
			'editorial-narrow': {
				base: 'max-w-max-editorial-narrow',
			},
			'title-medium': {
				base: 'max-w-max-title-md',
			},
			unset: {
				base: '[--container-padding:0]!',
			},
		},
	},
});

export type ContainerProps = {
	as?: keyof JSX.IntrinsicElements;
	className?: string;
	size?: keyof typeof styles.variants.size;
} & HTMLAttributes<HTMLElement>;

export function Container({ as: El = 'div', size = 'default', className, ...props }: PropsWithChildren<ContainerProps>) {
	const { base } = styles({ size });

	return (
		// @ts-expect-error
		<El {...props} className={base({ className })}>
			{props.children}
		</El>
	);
}
